import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Userprofile } from 'src/app/models/user/current-user.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})
export class UserprofileComponent implements OnInit, OnDestroy {
  userid: any;
  userprofile: Userprofile = new Userprofile();
  userimage = "";
  private queryParamSubscription: Subscription;

  constructor(public activatedroute: ActivatedRoute, private router: Router, public headerinfo: ComponentheaderService, private usermanager: UseraccessserviceService) {
    // NOTE: this constructor used to set
    //   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // That is a *global* router setting and was never restored, so opening this page
    // once made every route in the application rebuild on every navigation for the
    // rest of the session. It existed because the user id was read from a snapshot,
    // so moving between two profiles reused the component and showed stale data.
    // Subscribing to the query params below handles that properly and locally.
  }

  ngOnInit(): void {
    this.queryParamSubscription = this.activatedroute.queryParams.subscribe(params => {
      const requested = params['userid'];
      this.userid = requested > 0 ? requested : 0;
      this.load();
    });
  }

  ngOnDestroy(): void {
    this.queryParamSubscription?.unsubscribe();
  }

  private async load() {
    this.headerinfo.pageLoadingStarted(this);
    try {
      await this.getprofile(this.userid);
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  async getprofile(userid: any) {
    this.userprofile = await this.usermanager.getuserprofile(userid).toPromise();
    // this.userimage = (await this.usermanager.getuserprofileimage(userid).toPromise()).url + '?' + (new Date()).getTime();
    this.userimage = (await this.usermanager.getuserprofileimage(userid).toPromise()).url;
    const currentuserid: any = (await this.usermanager.isAlive().toPromise()).id;

    let adminaction = [];
    if (userid == 0 || userid == currentuserid) {
      adminaction = [{ displaytext: 'Edit Profile', route: '/user/editprofile', params: { userid: this.userid }, classes: ['fas', 'fa-edit'] },
      { displaytext: 'Change Password', route: '/user/updatepassword', params: {}, classes: ['fas', 'fa-lock'] }
      ];
    }
    this.headerinfo.setHeaderDisplay(
      'User Profile',
      [
        // { displaytext: 'Home', route: '/user' },
        { displaytext: 'User Profie', route: '/user/userprofile', params: this.activatedroute.snapshot.queryParams },
      ],
      adminaction
    );
  }

}
